'use es6';

import KeyMirror from 'react-utils/keyMirror';
export default KeyMirror({
  FACEBOOK: null,
  ADWORDS: null,
  LINKEDIN: null
});